import { apiService } from '.';
import { cleanObj } from '../shared/utils/objects';

export type InteractionRow = {
    id: string;
    createdAt: string;
    caseId: string | null;
    sarlaftId: string | null;
    typification: string | null;
    observation: string | null;
    caseStatus: string | null;
    plate: string | null;
    policy: string | null;
    callId: string | null;
    userName: string | null;
    channelId: string | null;
    channel: string | null;
    identification: string | null;
    source: string;
};

export type InteractionsPayload = { total: number; data: InteractionRow[] };
export type ApiWrapped<T> = { items: T };

export type InteractionsResponse =
    | { total: number; data: InteractionRow[] }
    | InteractionRow[];

export async function fetchInteractions(params: {
    channel?: string;
    identification?: string;
    plate?: string;
    policy?: string;
    offset?: number;
    limit?: number;
}) {
    return apiService.get<ApiWrapped<InteractionsPayload>>(
        `/api/interactions-history/others`,
        cleanObj(params)
    );
}

export async function fetchInteractionsPqr(params: {
    identification?: string;
    plate?: string;
    policy?: string;
    channelId?: string;
    offset?: number;
    limit?: number;
}) {
    return apiService.get<ApiWrapped<InteractionsPayload>>(
        `/api/interactions-history/pqr`,
        cleanObj(params)
    );
}

export async function fetchInteractionsAll(params: {
    historyType?: 'APP' | 'CHAT' | 'CHATBOT' | 'TELEFONÍA' | 'PQR';
    channelId?: string;
    identification?: string;
    plate?: string;
    policy?: string;
    offset?: number;
    limit?: number;
}) {
    return apiService.get<ApiWrapped<InteractionsPayload>>(
        `/api/interactions-history/all`,
        cleanObj(params)
    );
}
